import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { derogationsQueryKeys } from "../query-keys/derogations.query-keys";

export const offerHasDerogation = async (
	constructionSiteId: number,
	binderWarrantyId: number,
) => {
	const { data } = await privateAxios.get<boolean>(
		`/derogations/offer-has-derogation/${constructionSiteId}/${binderWarrantyId}`,
	);
	return data;
};

export const useOfferHasDerogation = (
	constructionSiteId: number,
	binderWarrantyId: number,
) => {
	return useQuery({
		queryKey: derogationsQueryKeys.offerHasDerogation(
			constructionSiteId,
			binderWarrantyId,
		),
		queryFn: () => offerHasDerogation(constructionSiteId, binderWarrantyId),
	});
};
